<template>
  <div>
    <mdb-modal scrollable size="lg" @shown="componentDidMount" :show="visible" @close="hideModal">
      <mdb-modal-header>
        <mdb-modal-title>Order Detail {{this.order?this.order.order_number:""}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-container>
            <mdb-row v-if="loading">
                <mdb-col col="12" class="d-flex flex-center" >
                    <mdb-spinner />
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3" v-if="!loading && this.order && this.order.service_id==1 && this.order.merchant.is_pb==1">
                <mdb-col col="12">
                    <div class="pb-remark">PB Order</div>
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3" v-if="!loading && this.order && this.order.service_id==1 && this.order.merchant.is_mart==1">
                <mdb-col col="12">
                    <div class="mart-remark">Mart Order</div>
                </mdb-col>
            </mdb-row>
            <mdb-row  v-if="!loading" class="mb-3">
                <mdb-col md="6">
                    <mdb-card>
                        <mdb-card-body>
                            <textarea id="txt-pickup-textarea" class="copy-clipboard" v-model="textarea_pickup" />
                            <div style="border-bottom: 1px solid grey">
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Copy Clipboard</span>
                                    <a @click="copyClipboard('pickup')" slot="reference">
                                        Pick Up <i class="far fa-clone"></i>  
                                    </a>
                                </mdb-tooltip>
                            </div>
                            <div class="text-primary">{{this.order?this.order.pickup.name:""}}</div>
                            <div class="small">{{this.order?this.order.pickup.address:""}}</div>
                            <div class="small">Numbering: {{this.order?this.order.pickup.remarks:""}}</div>
                            <div class="small" v-if="this.order && this.order.service_id==1">{{this.order?this.order.merchant.contact_number:""}}</div>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Google Map</span>
                                <a slot="reference" target="_blank" :href="`https://www.google.com/maps?q=${this.order.pickup.lat},${this.order.pickup.lng}`">
                                    <i class="far fa-map"></i> Open Map
                                </a>
                            </mdb-tooltip>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-card>
                        <mdb-card-body>
                            <textarea id="txt-deliver-textarea" class="copy-clipboard" v-model="textarea_deliver" />
                            <div style="border-bottom: 1px solid grey">
                                <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                    <span slot="tip">Copy Clipboard</span>
                                    <a @click="copyClipboard('deliver')" slot="reference">
                                        Deliver <i class="far fa-clone"></i>
                                    </a>
                                </mdb-tooltip>
                            </div>
                            <div class="text-success">{{this.order?this.order.deliver.name:""}}</div>
                            <div class="small">{{this.order?this.order.deliver.address:""}}</div>
                            <div class="small">Unit/Tingkat: {{this.order?this.order.deliver.remarks:""}}</div>
                            <div class="small">Note to Rider: {{this.order?this.order.note_customer:""}}</div>
                            <div class="small">{{this.order?this.order.customer_user.phone_number:""}}</div>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Google Map</span>
                                <a slot="reference" target="_blank" :href="`https://www.google.com/maps?q=${this.order.deliver.lat},${this.order.deliver.lng}`">
                                    <i class="far fa-map"></i> Open Map
                                </a>
                            </mdb-tooltip>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row  v-if="!loading" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Order Information</h4>
                            <mdb-container fluid>
                                <mdb-row class="py-1" v-for="item in order.all_items" style="border-bottom: 1px solid grey" :key="item.id">
                                    <mdb-col col="6" class="text">
                                        <div :class="{'text-danger': item.is_available==0}">
                                            {{item.allproduct.allcategory.name}}
                                        </div>
                                        <div v-if="order.status=='NEW'" class="font-weight-bold d-flex flex-column">
                                            <div v-if="order.service_id==2">{{item.allproduct.merchant.name}}</div>
                                            <mdb-tooltip v-if="item.is_available==1" trigger="hover" :options="{placement: 'top'}">
                                                <span slot="tip">Click to remove item</span>
                                                <a slot="reference" target="_blank" @click="itemNotAvailable(item)">
                                                    {{item.name}} <mdb-icon class="text-danger" far icon="trash-alt" />
                                                </a>
                                            </mdb-tooltip>
                                            <div v-if="item.is_available==0" class="d-flex flex-row align-items-center text-danger">
                                                {{item.name}} 
                                                <mdb-icon v-if="item.is_available==0" class="ml-1" icon="times" />
                                            </div>
                                        </div>
                                        <div v-if="order.status!='NEW'" class="font-weight-bold d-flex flex-column">
                                            <div v-if="order.service_id==2">{{item.allproduct.merchant.name}}</div>
                                            <div class="d-flex flex-row align-items-center" :class="{'text-danger': item.is_available==0}">
                                                {{item.name}} 
                                                <mdb-icon v-if="item.is_available==0" class="text-danger ml-1" icon="times" /> 
                                                <mdb-icon v-if="item.is_available==1" class="text-success ml-1" icon="check" />
                                            </div>
                                        </div>
                                        <div style="font-size: 0.75rem" :class="{'text-danger': item.is_available==0}">
                                            {{item.allproduct.description}}
                                        </div>
                                        <div v-for="variety in item.std_variety" :key="variety.id">
                                            <div>{{variety.name}}: <span v-for="option in variety.options" :key="option.name">
                                                <span v-if="option.checked">{{option.name}} ({{parseFloat(option.price).toFixed(2)}})</span>
                                            </span>
                                            </div>
                                        </div>
                                        <div v-if="item.remarks" :class="{'text-danger': item.is_available==0}">Remarks: {{item.remarks}}</div>
                                    </mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        <div class="text" :class="{'text-danger': item.is_available==0}">{{item.quantity}} items</div>
                                        <div class="text" :class="{'text-danger': item.is_available==0}">RM {{item.service_charge_node.amount}}</div>
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" style="border-bottom: 1px solid grey">
                                    <mdb-col col="6" class="text font-weight-bold">Total Items</mdb-col>
                                    <mdb-col col="6" class="text-right font-weight-bold">
                                        {{this.item_quantity}}
                                    </mdb-col>
                                </mdb-row>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row  v-if="!loading" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Payment Information</h4>
                            <mdb-container fluid>
                                <mdb-row class="py-1">
                                    <mdb-col col="6" class="text">Subtotal</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.item_price)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.tax_amount!='0.00'">
                                    <mdb-col col="6" class="text">Tax</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.tax_amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1">
                                    <mdb-col col="6" class="text">Delivery Fees</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.deliver.service_charge_node.amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.service_fee!='0.00'">
                                    <mdb-col col="6" class="text">Combine Fees</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.service_fee)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" v-if="this.order.service_charge.promo_code_paid!='0.00'">
                                    <mdb-col col="6" class="text">Promo Discount ({{this.order.service_charge.promo_code?this.order.service_charge.promo_code.promo_code_config.code:""}})</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.service_charge.promo_code_paid)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row v-if="this.order.small_order_fee" class="py-1">
                                    <mdb-col col="6" class="text">Small Order Fee</mdb-col>
                                    <mdb-col col="6" class="text-right">
                                        RM {{parsePrice(this.order.small_order_fee.service_charge_node.amount)}}
                                    </mdb-col>
                                </mdb-row>
                                <mdb-row class="py-1" style="border-top: 1px solid #2E2E2E; border-bottom: 1px solid #2E2E2E">
                                    <mdb-col col="6" class="text font-weight-bold">Total</mdb-col>
                                    <mdb-col col="6" class="text-right font-weight-bold">
                                        RM {{parsePrice(this.order.service_charge.grand_total)}}
                                    </mdb-col>
                                </mdb-row>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row  v-if="!loading && order.service_order_event.length!=0" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Event Information</h4>
                            <mdb-container fluid>
                                <mdb-row v-for="event in order.service_order_event" v-bind:key="event.id">
                                    <mdb-col col="4">
                                        {{event.code_type}}
                                    </mdb-col>
                                    <mdb-col col="4">
                                        {{event.description}}
                                    </mdb-col>
                                    <mdb-col col="4">
                                        {{momentFormat16(event.created_at)}}
                                    </mdb-col>
                                </mdb-row>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row v-if="!loading && promo_codes" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Promo Code (User Binded)</h4>
                            <mdb-container fluid>
                                <mdb-row>
                                    <mdb-col col="8">
                                        <select v-model="selected_promo_code" class="browser-default custom-select">
                                            <option value="" selected disabled>Select Promo Code</option>
                                            <option v-for="promo in promo_codes" v-bind:key="promo.id" :value="promo.id">{{promo.code}}</option>
                                        </select>
                                    </mdb-col>
                                    <mdb-col col="4">
                                        <mdb-btn v-if="!promo_code_loading" @click="submitPromoCode" color="primary" size="sm">
                                            Submit
                                        </mdb-btn>
                                        <mdb-spinner v-if="promo_code_loading" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-container>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3" v-if="!loading && this.order && this.order.service_id==1 && this.order.merchant.is_pb==1">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">PB Attachments</h4>
                            <mdb-row class="mb-3">
                                <mdb-col col="12">
                                    <select :disabled="order.pb_amount!=0" v-model="order.pb_user_id" class="browser-default custom-select">
                                        <option :value="null" disabled selected>Select Payer</option>
                                        <option value="0">Lapar</option>
                                        <option v-if="order.partner_user" :value="order.partner_user.id">{{order.partner_user.partner_profile.fullname}}</option>
                                    </select>
                                </mdb-col>
                            </mdb-row>
                            <mdb-row>
                                <mdb-col v-for="(image,index) in attachments" v-bind:key="image.image_url+'_'+index" col="3" class="d-flex flex-column align-items-center">
                                    <img @click="showLightBox(index)" class="waves-effect img-fluid" :src="renderAttachment(image.image_url)" />
                                    <mdb-btn v-if="image.status=='NEW'" class="top-right-btn" @click="deleteAttachment(index)" color="danger" size="sm"><mdb-icon icon="times" /></mdb-btn>
                                    <mdb-input :disabled="order.pb_amount!=0" outline type="text" placeholder="RM" v-model="image.amount" />
                                </mdb-col>
                                <mdb-col v-if="order.pb_amount==0" col="3" class="py-2">
                                    <mdb-spinner v-if="loading_upload" small />
                                    <mdb-btn v-if="!loading_upload" size="sm" @click="showAttachmentUpload">
                                        <mdb-icon far icon="plus-square" /> Add Attachments
                                    </mdb-btn>
                                </mdb-col>
                            </mdb-row>
                            <hr />
                            <mdb-row>
                                <mdb-col col="6" class="d-flex align-items-end">Total: <strong class="ml-1">RM {{parseFloat(total_attachment_amount).toFixed(2)}}</strong></mdb-col>
                                <mdb-col col="6" class="d-flex align-items-end justify-content-end">
                                    <mdb-btn v-if="!loading_upload && order && order.pb_amount==0 && attachments.length!=0 && order.pb_user_id!=null" size="sm" @click="submitPartnerAttachments">
                                        Submit Attachments
                                    </mdb-btn>
                                </mdb-col>
                            </mdb-row>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
            <mdb-row  v-if="!loading" class="mb-3">
                <mdb-col md="12">
                    <mdb-card>
                        <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Admin Remarks</h4>
                            <div v-html="order.comment_admin" style="white-space: pre-wrap;"><br/></div>
                            <mdb-input outline type="textarea" v-model="admin_comment" :rows="2" />
                            <mdb-btn color="success" size="sm" @click="updateRemarks">Update Remarks</mdb-btn>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
        </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn v-if="!loading" color="warning" @click.native="dispute">Dispute Order</mdb-btn>
        <mdb-btn color="info" v-if="!loading && checkAcceptOrder()" @click.native="acceptOrder()">Accept Order</mdb-btn>
        <mdb-btn color="danger" v-if="!loading && checkCancelOrder()" @click.native="showConfirmationModal()">Cancel Order</mdb-btn>
        <mdb-btn v-if="!loading" color="secondary" @click.native="hideModal">Close</mdb-btn>
      </mdb-modal-footer>
      <mdb-lightbox
        :visible="lightbox_modal"
        :imgs="lightbox_imgs"
        :index="lightbox_index"
        @hide="lightbox_modal=false"
        ></mdb-lightbox>
      <input multiple type="file" @change="attachmentUpload" id="document-upload" hidden />
      <DisputeModal :order="order" :visible="dispute_modal" :close="closeModal" />
      <ConfirmationModal :title="'Are you sure you want to cancel order?'" :visible="show_confirmation_modal" :close="closeModal" :submit="cancelOrder" />
      <ConfirmationModal :text="remove_item_text" :title="focus_item!=null?focus_item.name + ' not available?':''" :visible="show_remove_item_modal" :close="closeModal" :submit="removeOrderItem" />
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbContainer, mdbRow, mdbCol, mdbSpinner,
  mdbCard, mdbCardBody, mdbInput, mdbTooltip, mdbIcon, mdbLightbox } from 'mdbvue';
  import {ajax, fileUploadAjax} from '../js/ajax';
  import {momentFormat16, checkPermissionsBinary} from '../js/helper';
  import {getColor} from '../js/colors';
  import ConfirmationModal from '../components/ConfirmationModal';
  import DisputeModal from '../components/DisputeOrderModal'
  import {APP_FILE_URL} from '../js/config'
  import {validateNumber} from '../js/validation';

  export default {
    components: {
      mdbModal, mdbInput, mdbTooltip,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,mdbIcon, mdbLightbox,
      mdbBtn, mdbContainer, mdbRow, mdbCol,
      mdbSpinner, mdbCard, mdbCardBody, ConfirmationModal,
      DisputeModal
    },
    props: ['visible', 'close', "id", 'callback', 'promo_codes'],
    data: ()=>({
        loading: true,
        order: null,
        item_quantity: 0,
        item_price: 0,
        map: null,
        admin_comment: "",
        show_confirmation_modal: false,
        textarea_pickup:"",
        textarea_deliver: "",
        selected_promo_code: "",
        promo_code_loading:false,
        order_merchants: [],
        dispute_modal: false,
        show_remove_item_modal: false,
        focus_item: null,
        remove_item_text: "",
        loading_upload: false,
        attachments: [],
        total_attachment_amount: "0.00",
        lightbox_modal: false,
        lightbox_imgs: [],
        lightbox_index: 0,
    }),
    methods: {
        componentDidMount(){
            this.order=null;
            this.loading=true;
            this.getData();
        },
        getData(){
            this.loading=true;
            this.selected_promo_code="";
            ajax({
                url: "admin/get_order_detail",
                data: {
                    id:this.id
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    if(!this.visible){
                        this.order=null;
                        this.loading=true;
                        return false;
                    }
                    this.item_quantity=result.data.item_quantity;
                    this.item_price=result.data.item_price;
                    this.order=result.data;
                    this.attachments=result.data.service_order_partner_attachments;
                    result.data.all_items.forEach(element => {
                        element.std_variety=JSON.parse(element.variety);
                        element.order=result.data.virtual_order_merchants.find(order=>{
                            return element.partner_user_id==order.merchant_id;
                        })
                    });
                    this.textarea_pickup=`Name: ${this.order.pickup.name}.\nAddress: ${this.order.pickup.address}.\nContact: ${this.order.merchant.contact_number}.\nMap: https://www.google.com/maps?q=${this.order.pickup.lat},${this.order.pickup.lng}`;
                    this.textarea_deliver=`Name: ${this.order.deliver.name}.\nAddress: ${this.order.deliver.address}.\nContact: ${this.order.customer_user.phone_number}.\nRemark: ${this.order.deliver.remarks?this.order.deliver.remarks:""}\nNote: ${this.order.note_customer?this.order.note_customer:""}\nMap: https://www.google.com/maps?q=${this.order.deliver.lat},${this.order.deliver.lng}`;
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        acceptOrder(){
            ajax({
                url: "admin/accept_merchant_order",
                data: {
                    id:this.order.id
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    this.getData();
                    this.callback?this.callback(result.data):null;
                    this.$notify.success({message: "Order Accepted", position: 'top right', timeOut: 5000})
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        cancelOrder(){
            ajax({
                url: "admin/cancel_order",
                data: {
                    id:this.order.id
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    this.getData();
                    this.callback?this.callback(result.data):null;
                    this.$notify.success({message: "Order Cancelled", position: 'top right', timeOut: 5000})
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        hideModal(){
            this.order=null;
            this.lightbox_modal=false;
            this.dispute_modal=false;
            this.lightbox_imgs=[];
            this.lightbox_index=0;
            this.loading=true;            
            this.close();
        },
        parsePrice(price){
            return parseFloat(price).toFixed(2);
        },
        renderMap(pickup, deliver){
            const google = window.google;
            var mapProp = {
                center:new google.maps.LatLng(3.0764785,101.4828676),
                zoom:12,
            };
            this.map=new google.maps.Map(document.getElementById("map"),mapProp);
            let pickup_point = new google.maps.LatLng(pickup.lat,pickup.lng);
            var pickup_marker_image = {
                url: require('@/assets/restaurant_marker.png'),
                scaledSize: new google.maps.Size(25, 25)
            };
            var pickup_marker = new google.maps.Marker({
                position: pickup_point,
                title:pickup.name,
                icon: pickup_marker_image
            });
            let destination = new google.maps.LatLng(deliver.lat,deliver.lng);
            var destination_marker_image = {
                url: require('@/assets/house_marker.png'),
                scaledSize: new google.maps.Size(25, 25)
            };
            var destination_marker = new google.maps.Marker({
                position: destination,
                title:deliver.name,
                icon:destination_marker_image
            });

            if(this.order.partner_online && this.order.status=="NEW"){
                let partner_location = new google.maps.LatLng(this.order.partner_online.lat,this.order.partner_online.lng);
                var partner_marker_image = {
                    url: require('@/assets/rider_marker.png'),
                    scaledSize: new google.maps.Size(25, 25)
                };
                var partner_marker = new google.maps.Marker({
                    position: partner_location,
                    title: this.order.partner_user.name,
                    icon:partner_marker_image
                });
                partner_marker.setMap(this.map);
            }

            if(this.order.service_order_event){
                this.order.service_order_event.forEach(element => {
                    if(element.code_type=="PARTNER_LOCATION"||element.code_type=="PICKUP"||element.code_type=="DELIVER"){
                        let location = new google.maps.LatLng(element.lat,element.lng);
                        let img='';
                        let description='';
                        switch(element.code_type){
                            case "PARTNER_LOCATION" : {
                                img=require('@/assets/received.png');
                                description="Accept: "+momentFormat16(element.created_at);
                                break;
                            }
                            case "PICKUP" : {
                                img=require('@/assets/pickup.png');
                                description="Pickup: "+momentFormat16(element.created_at);
                                break;
                            }
                            case "DELIVER" : {
                                img=require('@/assets/deliver.png');
                                description="Deliver: "+momentFormat16(element.created_at);
                                break;
                            }
                        }
                        var marker_image = {
                            url: img,
                            scaledSize: new google.maps.Size(25, 25)
                        };
                        var marker = new google.maps.Marker({
                            position: location,
                            title: description,
                            icon:marker_image
                        });
                        marker.setMap(this.map);
                    }
                    return;
                });
            }
            
            destination_marker.setMap(this.map);
            pickup_marker.setMap(this.map);
            let bounds = new google.maps.LatLngBounds(pickup_point,destination);
            this.map.fitBounds(bounds);
        },
        getColor(text){
            return getColor(text);
        },
        momentFormat16(date){
            return momentFormat16(date);
        },
        updateRemarks(){
            ajax({
                url: "admin/submit_remarks",
                data: {
                    id:this.order.id,
                    admin_comment: this.admin_comment
                },
                success: ()=>{
                    if(this.order.comment_admin){
                        this.order.comment_admin=this.order.comment_admin+'<br/>'+this.admin_comment;
                    }else{
                        this.order.comment_admin=this.admin_comment;
                    }
                    this.admin_comment="";
                    this.$notify.success({message: "Admin Remarks Updated", position: 'top right', timeOut: 5000});
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        checkAcceptOrder(){
            if(!this.permissionCheck(8)){
                return false;
            }
            if(this.order && this.order.status=='NEW' && this.order.current_step=='NEW'){
                return true;
            }
            return false;
        },
        checkCancelOrder(){
            if(!this.permissionCheck(10)){
                return false;
            }
            if(this.order && this.order.status=='NEW' && this.order.current_step!="PENDING_PAYMENT"){
                return true;
            }
            return false;
        },
        permissionCheck(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions);
        },
        closeModal(){
            this.show_confirmation_modal=false;
            this.dispute_modal=false;
            this.show_remove_item_modal=false;
        },
        showConfirmationModal(){
            this.show_confirmation_modal=true;
        },
        copyClipboard(type){
            var copyText=null;
            if(type=="pickup"){
                copyText = document.getElementById("txt-pickup-textarea");
            }else{
                copyText = document.getElementById("txt-deliver-textarea");
            }

            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            this.$notify.info({message: "Copied to clipboard", position: 'top right', timeOut: 5000});
        },
        submitPromoCode(){
            if(!this.permissionCheck(29)){
                this.$notify.error({message: "Permission Denied", position: 'top right', timeOut: 5000})
                return false;
            }
            if(this.promo_code_loading){
                return false;
            }
            this.promo_code_loading=true;
            ajax({
                url: "admin/submit_compensate_voucher",
                data: {
                    user_id:this.order.customer_user.id,
                    promo_code_id: this.selected_promo_code,
                    service_order_id: this.order.id
                },
                complete: ()=>this.promo_code_loading=false,
                success: ()=>{
                    this.$notify.success({message: "Promo Code Added", position: 'top right', timeOut: 5000})
                    this.getData();
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        dispute(){
            if(checkPermissionsBinary(45, this.$store.state.permissions)){
                sessionStorage.setItem('focus_order', JSON.stringify(this.order));
                this.$router.push({ name: 'order_dispute', params: {order: this.order} })
            }else{
                this.$notify.error({message: "Access Denied", position: 'top right', timeOut: 5000})
            }
        },
        itemNotAvailable(item){
            //check after deduction cannot be less than RM 7
            let grant_total =  parseFloat(this.order.service_charge.grand_total) - parseFloat(item.service_charge_node.amount);
            if(grant_total < 7 || grant_total < this.order.service_charge.promo_code_paid){
                this.remove_item_text=`Grand Total after Deduction: RM ${grant_total.toFixed(2)}. Condition not met. Please Cancel Order Instead.`;
            }else{
                this.remove_item_text="";
            }
            this.focus_item=item;
            this.show_remove_item_modal=true;
        },
        removeOrderItem(){
            if(!this.permissionCheck(48)){
                this.$notify.error({message: "Access Denied", position: 'top right', timeOut: 5000})
                return false;
            }
            let grant_total =  parseFloat(this.order.service_charge.grand_total) - parseFloat(this.focus_item.service_charge_node.amount);
            if(grant_total < 7 || grant_total < this.order.service_charge.promo_code_paid){
                this.$notify.error({message: "Please Cancel Order Instead.", position: 'top right', timeOut: 5000})
                this.show_remove_item_modal=false;
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/remove_order_item",
                data: {
                    id: this.focus_item.id
                },
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.getData();
                },
            }, this)
        },
        deleteAttachment(index){
            var temp=[...this.attachments];
            temp.splice(index, 1);
            this.attachments=temp;
        },
        showAttachmentUpload(){
            document.getElementById("document-upload").click();
        },
        attachmentUpload(event){
            this.loading_upload=true;
            fileUploadAjax({
                url: "admin/upload_service_order_attachments",
                data: {event: event.target.files},
                complete: ()=>this.loading_upload=false,
                success: result=>{
                    result.data.forEach(element => {
                        let obj=new Object();
                        obj.image_url=element;
                        obj.amount=0;
                        obj.status="NEW";
                        this.attachments=this.attachments.concat(obj);
                    });
                },
                isShowAlert: true
            }, this)
        },
        renderAttachment(image=null){
            return image?APP_FILE_URL+image:require('@/assets/picture.png');
        },
        submitPartnerAttachments(){
            if(!checkPermissionsBinary(68, this.$store.state.permissions)){
                this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
                return false;
            }
            let validation_continue=true;
            this.attachments.forEach(element => {
                if(!validateNumber(element.amount)){
                    validation_continue=false;
                }
            });
            if(!validation_continue){
                this.$notify.error({message: "Invalid Attachment Amount", position: 'top right', timeOut: 5000})
                return false;
            }
            this.loading_upload=true;
            ajax({
                url: "admin/submit_service_order_attachments",
                data: {service_order_id: this.order.id, attachments: this.attachments, pb_user_id: this.order.pb_user_id},
                complete: ()=>this.loading_upload=false,
                success: result=>{
                    this.callback?this.callback(result.data):null;
                    this.$notify.success({message: "Partner Attachments Updated", position: 'top right', timeOut: 5000})
                },
                isShowAlert: true
            }, this)
        },
        showLightBox(index){
            var temp_images=[];
            this.attachments.forEach(element => {
                temp_images.push(APP_FILE_URL+element.image_url);
            });
            this.lightbox_modal=true,
            this.lightbox_imgs=temp_images,
            this.lightbox_index=index;
        }
    },
    watch: {
        attachments: {
            handler(val){
                let total_attachment_amount=0;
                val.forEach(element => {
                    if(validateNumber(element.amount)){
                        total_attachment_amount=total_attachment_amount+parseFloat(element.amount);
                    }
                });
                this.total_attachment_amount=total_attachment_amount;
            },
            deep: true
        }
    }
  };
</script>

<style scoped>
#map{
    height: 400px;
    width: 100%;
}
.copy-clipboard{
    position: absolute;
    left: -999999999px;
    z-index: -100;
}
.pb-remark{
    background-color: #E91E63;
    color: #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 20px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.mart-remark{
    background-color: #4caf50;
    color: #fff;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    display: flex;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.top-right-btn{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
}
</style>